import * as React from 'react';
import moment from 'moment';

import { FC, useEffect, useState } from 'react';
import SimpleTable from 'src/components/common/SimpleTable/SimpleTable';

import { ICase } from 'src/types/case';
import { ISeanceStatistics, ISeance } from 'src/types/seance';
import SessionComponent from '../components/SessionTable';
import MobileSessionComponent from '../components/MobileSessionComponent';
import TotalTable from '../components/TotalTable';
import styles from '../components/editSession/assets/seances-form.module.scss';
import { getDetailCase } from 'src/helpers/case/caseDetail';
import Loader from '../../../../../../../../../components/Loader';
import { QueryParams } from '../../../../../../../../../types/grid';
import { Paginated } from '../../../../../../../../../services/api-handlers/pagination';
import InfoItem from '../../../../../../../../../components/InfoItem';
import { useDispatch } from 'react-redux';
import { updateSeance } from '../../../../../../../../../store/actions/seance-actions';
import { getProgramBooks, getProgramBooksSmall } from '../../../../../../../../../store/actions/program-book-actions';
import { toast } from 'react-toastify';
import { IProvider } from '../../../../../../../../../types/provider';
import { IInvoice } from '../../../../../../../../../types/invoice';
import classNames from 'classnames';
import { History } from 'history';
import Router from '../../../../../../../../../navigation/router';
import { routes } from '../../../../../../../../../navigation';
import { changeToZeroMoment } from '../../../../../../../../../helpers/timeHelpers';
import { numberWithCommas } from '../../../../../../../../../helpers/format';
import user from '../../../../../../../../../services/user-auth';
import UserRole from '../../../../../../../../../enumerables/user-role';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { Button, Modal } from 'react-bootstrap';
import { sendToParent } from '../../../../../../../../../store/actions/invoice-actions';
import { sendStatementToParent } from '../../../../../../../../../store/actions/invoice-actions';

export interface StateProps {
    caseCurrent: ICase | null;
    statistics: ISeanceStatistics | null;
    seances: Paginated<ISeance>;
    seancesList: Paginated<ISeance>;
    serviceTypes: SelectObject[];
    statementDocs: any;
    serviceLocations: SelectObject[];
    inProgress: boolean;
    baseConfig: any;
    inProgressSeance: boolean;
    inProgressInvoice: boolean;
    inProgressSeancesList: boolean;
}

export interface DispatchProps {
    getData: (id: string | number) => void;
    getStatistics: (params: any) => void;
    createInvoiceAction: (params: any, setPopup: (param: boolean) => void) => void;
    createStatementAction: (params: any, setPopup: (param: boolean) => void) => void;
    getDataSeance: (params: QueryParams) => void;
    getSeancesList: (params: QueryParams) => void;
}

export interface OwnProps {
    idCase: string | boolean;
    history: History;
    provider: Partial<IProvider> | null;
    providerUrlId: string;
    month: { monthEnd: string; monthStart: string };
    cases: Paginated<ICase>;
    invoices: Paginated<IInvoice>;

    // caseEnt: ICase | null;
}
export interface Props extends StateProps, DispatchProps, OwnProps {}
const CaseSessionTab: FC<Props> = ({
    caseCurrent,
    idCase,
    history,
    serviceLocations,
    serviceTypes,
    cases,
    providerUrlId,
    inProgressSeance,
    inProgressSeancesList,
    seances,
    seancesList,
    inProgressInvoice,
    getStatistics,
    createInvoiceAction,
    createStatementAction,
    inProgress,
    provider,
    baseConfig,
    month,
    invoices,
    getDataSeance,
    getSeancesList,
    statistics,
    statementDocs,
}: Props) => {
    const dispatch = useDispatch();

    const [notOpened, setOpened] = useState(true);
    const [statusEnum, setStatus] = useState({});
    const [openedToParent, setOpenedToParent] = useState(false);
    const [openedStatementToParent, setOpenedStatementToParent] = useState(false);
    const handleClose = () => {
        setOpened(false);
        setOpenedToParent(false);
        setOpenedStatementToParent(false);
    };

    const sendInvoiceToParent = (id: string | number) => {
        dispatch(
            sendToParent(
                { id: id },
                {
                    resolve: () => {
                        toast.success('Invoice has just been sent to Parent');
                    },
                    reject: (errorMessage: string) => {
                        toast.error(errorMessage);
                    },
                },
            ),
        );
        handleClose();
    };

    const sendStatementsToParent = (id: string | number) => {
        dispatch(
            sendStatementToParent(
                { id: id },
                {
                    resolve: () => {
                        toast.success('Statement has just been sent to parent');
                    },
                    reject: (errorMessage: string) => {
                        toast.error(errorMessage);
                    },
                },
            ),
        );
        handleClose();
    };

    // eslint-disable-next-line prefer-const
    useEffect(() => {
        if (caseCurrent?.orderEntity?.id || caseCurrent?.student?.id) {
            dispatch(
                getProgramBooksSmall({
                    filters: {
                        //'orderEntity.id': caseCurrent?.orderEntity?.id,
                        'student.id': caseCurrent?.student?.id,
                    },
                    page: 1,
                    itemsPerPage: 1,
                }),
            );
        }

        // eslint-disable-next-line
    }, [caseCurrent?.orderEntity?.id, caseCurrent?.student?.id]);

    useEffect(() => {
        if (!Object.values(statusEnum).length && Object.values(baseConfig).length) {
            setStatus(baseConfig ? baseConfig.SeanceStatus : {});
        }

        // eslint-disable-next-line
    }, [baseConfig]);

    const updateSeanceAction = (status: number, id: string, setPopup: (param: boolean) => void) =>
        dispatch(
            updateSeance(
                { status, id },
                () => {
                    getStatistics({ occasion: +idCase, dateFrom: month.monthStart, dateTo: month.monthEnd });
                    toast.success('Status changed successfully');
                    setPopup(false);
                },
                (errorMessage: string) => {
                    setPopup(false);
                    getStatistics({ occasion: +idCase, dateFrom: month.monthStart, dateTo: month.monthEnd });
                    toast.error(errorMessage);
                },
            ),
        );

    if (!caseCurrent) return <Loader />;
    const rowData = getDetailCase({ ...caseCurrent });
    let weeksStatistics = null;
    let balance = null;
    let paidByDoe = null;
    let totalFee = null;
    if (statistics) {
        weeksStatistics = statistics.weeksStatistics;
        balance = `$${numberWithCommas(statistics.balance)}`;
        paidByDoe = `$${numberWithCommas(statistics.paidByDoe)}`;
        totalFee = `$${numberWithCommas(statistics.totalFee)}`;
    }

    const invoicesData: any = [];
    invoices.list.forEach((it: any) => {
        let value = it.createdAt;
        value = value ? `${changeToZeroMoment(value, 'MMM D, YYYY')}` : '';
        invoicesData.push({
            id: it.id,
            date: value,
            link: (
                <button
                    onClick={() => {
                        window.scrollTo(0, 0);
                        /*   history.push(
                                Router.generate(routes.PROVIDER_DETAIL, {
                                    id: provider?.id,
                                    tab: 'invoices-detail',
                                    subId: it.id,
                                }),
                            );*/
                        const win: any = window.open(
                            Router.generate(routes.PROVIDER_DETAIL, {
                                id: providerUrlId,
                                tab: 'invoices-detail',
                                subId: it.id,
                            }),
                            '_blank',
                        );
                        win.focus();
                    }}
                    className={'btn btn-info'}
                    style={{ paddingTop: '2px', paddingBottom: '2px' }}
                >
                    {value}
                </button>
            ),
            send: (
                <div>
                    {it?.occasion?.caseType === 2 && user.getRoles().includes(UserRole.ROLE_ADMIN) ? (
                        <div>
                            <button
                                style={{ paddingTop: '2px', paddingBottom: '2px' }}
                                className={'btn btn-info'}
                                onClick={() => setOpenedToParent(10 + it.id)}
                            >
                                <FontAwesomeIcon icon={faEnvelope} style={{ marginRight: '10px' }} />
                                Send to the parent
                            </button>
                            <Modal show={openedToParent === 10 + it.id} onHide={handleClose}>
                                <Modal.Header closeButton>
                                    <Modal.Title>Confirmation</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>Are you sure you want to send it to the parent?</Modal.Body>
                                <Modal.Footer>
                                    <Button variant="secondary" onClick={handleClose}>
                                        No
                                    </Button>
                                    <Button variant="success" onClick={() => sendInvoiceToParent(it?.id ? it?.id : 0)}>
                                        Yes
                                    </Button>
                                </Modal.Footer>
                            </Modal>
                        </div>
                    ) : null}
                </div>
            ),
        });
    });

    const statementGroupData: any = [];
    statementDocs.list.forEach((it: any) => {
        let value = it.statement.periodStart;
        value = value ? `${changeToZeroMoment(value, 'MMM D, YYYY')}` : '';
        const valueOrder = it.statement.periodStart ? moment.utc(it.statement.periodStart).zone('0').valueOf() : 0;

        let links = [];
        if (statementGroupData[it.statement.id]) {
            links = statementGroupData[it.statement.id].links;
            links.push(
                <a
                    rel="noopener noreferrer"
                    style={{ display: 'inline-block', marginRight: '10px' }}
                    target="_blank"
                    href={it.attach}
                    className={'btn btn-info'}
                >
                    {value}
                </a>,
            );
        } else {
            links.push(
                <a
                    rel="noopener noreferrer"
                    style={{ display: 'inline-block', marginRight: '10px' }}
                    target="_blank"
                    href={it.attach}
                    className={'btn btn-info'}
                >
                    {value}
                </a>,
            );
        }

        statementGroupData[it.statement.id] = {
            id: it.id,
            date: value,
            statementId: it.statement.id,
            dateOrder: valueOrder,
            links: links,
            link: links.join('<br>'),
            send: (
                <div>
                    {user.getRoles().includes(UserRole.ROLE_ADMIN) ? (
                        <div>
                            <button
                                style={{ paddingTop: '2px', paddingBottom: '2px' }}
                                className={'btn btn-info'}
                                onClick={() => setOpenedStatementToParent(it?.statement?.id)}
                            >
                                <FontAwesomeIcon icon={faEnvelope} style={{ marginRight: '10px' }} />
                                Send to the parent
                            </button>
                            <Modal show={openedStatementToParent === it?.statement?.id} onHide={handleClose}>
                                <Modal.Header closeButton>
                                    <Modal.Title>Confirmation</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>Are you sure you want to send it to the parent?</Modal.Body>
                                <Modal.Footer>
                                    <Button variant="secondary" onClick={handleClose}>
                                        No
                                    </Button>
                                    <Button
                                        variant="success"
                                        onClick={() =>
                                            sendStatementsToParent(it?.statement?.id ? it?.statement?.id : 0)
                                        }
                                    >
                                        Yes
                                    </Button>
                                </Modal.Footer>
                            </Modal>
                        </div>
                    ) : null}
                </div>
            ),
        };
    });

    const statementData: any = [];
    statementDocs.list.forEach((it: any) => {
        let value = it.statement.periodStart;
        value = value ? `${changeToZeroMoment(value, 'MMM D, YYYY')}` : '';
        const valueOrder = it.statement.periodStart ? moment.utc(it.statement.periodStart).zone('0').valueOf() : 0;
        statementData.push({
            id: it.id,
            date: value,
            statementId: it.statement.id + ' (document=' + it.id + ')',
            dateOrder: valueOrder,
            link: (
                <div>
                    <a rel="noopener noreferrer" target="_blank" href={it.attach} className={'btn btn-info'}>
                        {value}
                    </a>
                    <a rel="noopener noreferrer" target="_blank" href={it.attach} className={'btn btn-info'}>
                        {value}
                    </a>
                </div>
            ),
            send: (
                <div>
                    {user.getRoles().includes(UserRole.ROLE_ADMIN) ? (
                        <div>
                            <button
                                style={{ paddingTop: '2px', paddingBottom: '2px' }}
                                className={'btn btn-info'}
                                onClick={() => setOpenedStatementToParent(it?.statement?.id)}
                            >
                                <FontAwesomeIcon icon={faEnvelope} style={{ marginRight: '10px' }} />
                                Send to the parent
                            </button>
                            <Modal show={openedStatementToParent === it?.statement?.id} onHide={handleClose}>
                                <Modal.Header closeButton>
                                    <Modal.Title>Confirmation</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>Are you sure you want to send it to the parent?</Modal.Body>
                                <Modal.Footer>
                                    <Button variant="secondary" onClick={handleClose}>
                                        No
                                    </Button>
                                    <Button
                                        variant="success"
                                        onClick={() =>
                                            sendStatementsToParent(it?.statement?.id ? it?.statement?.id : 0)
                                        }
                                    >
                                        Yes
                                    </Button>
                                </Modal.Footer>
                            </Modal>
                        </div>
                    ) : null}
                </div>
            ),
        });
    });
    if (statementGroupData.length) {
        statementGroupData.sort((a: any, b: any) => {
            if (a.dateOrder > b.dateOrder) {
                return -1;
            }
            if (a.dateOrder < b.dateOrder) {
                return 1;
            }
            return 0;
        });
    }

    const isMobile = window.innerWidth <= 800;
    const isAdmin = user.getRoles().includes(UserRole.ROLE_ADMIN);
    return (
        <div className=" justify-content-md-center">
            {inProgressInvoice || inProgress || inProgressSeance || inProgressSeancesList ? <Loader /> : null}
            {isMobile ? (
                <MobileSessionComponent
                    provider={provider}
                    getData={getDataSeance}
                    statusEnum={statusEnum}
                    serviceLocations={serviceLocations}
                    serviceTypes={serviceTypes}
                    month={month}
                    caseCurrent={caseCurrent}
                    inProgressInvoice={inProgressInvoice}
                    cases={cases}
                    seances={seances}
                    seancesList={seancesList}
                    createInvoiceAction={createInvoiceAction}
                    createStatementAction={createStatementAction}
                    updateSeance={(param, param2, param3) => updateSeanceAction(param, param2, param3)}
                    data={seances}
                />
            ) : (
                <SessionComponent
                    provider={provider}
                    getData={getDataSeance}
                    month={month}
                    statusEnum={statusEnum}
                    serviceLocations={serviceLocations}
                    serviceTypes={serviceTypes}
                    caseCurrent={caseCurrent}
                    inProgressInvoice={inProgressInvoice}
                    cases={cases}
                    seances={seances}
                    seancesList={seancesList}
                    createInvoiceAction={createInvoiceAction}
                    createStatementAction={createStatementAction}
                    updateSeance={(param, param2, param3) => updateSeanceAction(param, param2, param3)}
                    data={seances}
                    getSeancesList={getSeancesList}
                />
            )}
            {isMobile ? (
                <button className={'btn btn-secondary mb-4 w-100'} onClick={() => setOpened(!notOpened)}>
                    {notOpened ? 'More' : 'Close'}
                </button>
            ) : null}
            <div style={isMobile && notOpened ? { display: 'none' } : { display: 'block' }}>
                <div className="row">
                    <div className="col col-md-6">
                        {isAdmin && statementGroupData.length ? (
                            <div>
                                <SimpleTable
                                    data={statementGroupData}
                                    classNameTable={classNames(styles.tableInvoice)}
                                    columns={[
                                        { id: 'statementId', label: 'id', cellStyle: 'normal-c' },
                                        { id: 'links', label: 'Statements', cellStyle: 'normal' },
                                        { id: 'send', label: '', cellStyle: 'normal' },
                                    ]}
                                />
                            </div>
                        ) : null}
                        {invoicesData.length ? (
                            <div>
                                <SimpleTable
                                    data={invoicesData}
                                    classNameTable={classNames(styles.tableInvoice)}
                                    columns={[
                                        { id: 'id', label: 'Id', cellStyle: 'normal-c' },
                                        { id: 'link', label: 'Invoices', cellStyle: 'normal' },
                                        { id: 'send', label: '', cellStyle: 'normal' },
                                    ]}
                                />
                            </div>
                        ) : null}
                        <TotalTable data={weeksStatistics} />
                    </div>
                    <div className="col col-md-6">
                        <div style={{ marginTop: -10 }}>
                            <InfoItem title={'Total Fee:'} value={totalFee} />
                            <InfoItem title={'Paid:'} value={paidByDoe} />
                            <InfoItem title={'Balance:'} value={balance} />
                        </div>
                    </div>
                </div>

                <SimpleTable
                    classNameTable={classNames(styles.table)}
                    data={rowData}
                    columns={[
                        { id: 'name', label: 'Details', cellStyle: 'normal' },
                        { id: 'value', label: '', cellStyle: 'normal' },
                    ]}
                />
            </div>
        </div>
    );
};

export default CaseSessionTab;
